import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import storeSynchronize from 'redux-localstore';
import createSagaMiddleware from 'redux-saga';
import { axiosInterceptor } from '@/shared/axiosInstance';
import authReducer from './reducers/auth';
import { limitsReducer } from './reducers/limitsReducer';
import { loginHistoryReducer } from './reducers/loginHistoryReducer';
import { modalReducer } from './modal/reducers';
import userReducer from './reducers/user';
import { userPlayStatsAndLimitsReducer } from './reducers/userPlayStatsAndLimitsReducer';
import { watchUserPlayStatsAndLimits } from './sagas/userPlayStatsAndLimitsSaga';
import { watchAuth, watchUser } from './sagas/index';
import { commonReducer } from './reducers/commonReducer';
import { watchLimits } from './sagas/limitsSaga';
import { watchLoginHistory } from './sagas/loginHistorySaga';
import { watchAutoLogin } from './sagas/autoLoginSaga';
import { autoLoginReducer } from './reducers/autoLoginReducer';
import { watchGames } from './games/sagas';
import { gamesReducers } from './games/reducers';
import { kycReducer } from './reducers/kycReducer';
import { watchKyc } from './sagas/kycSagas';
import { uiReducers } from './ui/reducers';
import { watchConsents } from './sagas/consentsSagas';
import { consentsReducer } from './reducers/consentsReducer';
import amlReducer from './reducers/amlReducer';
import { watchAml } from './sagas/amlSagas';
import { bffApiServiceInterceptor } from '@/shared/bffApiService';
import { promotionsReducer } from '@/store/cms/promotions/reducer';
import { watchPromotionsSagas } from '@/store/cms/promotions/sagas';
import { watchFaqSagas } from '@/store/cms/faq/sagas';
import { faqReducer } from '@/store/cms/faq/reducers';
import { watchWelcomeTextsSagas } from '@/store/cms/welcome-texts/sagas';
import { welcomeTextsReducer } from '@/store/cms/welcome-texts/reducers';
import { userWalletReducer } from '@/store/wallet/reducers';
import { watchUserWalletSagas } from '@/store/wallet/sagas';
import { watchHeaderBannersSagas } from '@/store/cms/header-banners/sagas';
import { headerBannersReducer } from '@/store/cms/header-banners/reducers';
import { heroBackgroundsReducer } from '@/store/cms/hero-backgrounds/reducers';
import { watchHeroBackgroundsSagas } from '@/store/cms/hero-backgrounds/sagas';
import { bonusesReducer } from '@/store/bonuses/reducers';
import { watchBonusesSagas } from '@/store/bonuses/sagas';

const rootReducer = combineReducers({
  aml: amlReducer,
  auth: authReducer,
  autoLogin: autoLoginReducer,
  common: commonReducer,
  consents: consentsReducer,
  faq: faqReducer,
  headerBanners: headerBannersReducer,
  bffGames: gamesReducers,
  kyc: kycReducer,
  limits: limitsReducer,
  loginHistory: loginHistoryReducer,
  modal: modalReducer,
  ui: uiReducers,
  user: userReducer,
  userPlayStatsAndLimits: userPlayStatsAndLimitsReducer,
  promotions: promotionsReducer,
  bonuses: bonusesReducer,
  welcomeTexts: welcomeTextsReducer,
  wallet: userWalletReducer,
  heroBackgrounds: heroBackgroundsReducer,
});

const sagaMiddleware = createSagaMiddleware();

/* Use this if you want to enable tracing for the redux devtools */
// const composeEnhancers = composeWithDevTools({ trace: true, maxAge: 200 });
// const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(watchAml);
sagaMiddleware.run(watchAuth);
sagaMiddleware.run(watchAutoLogin);
sagaMiddleware.run(watchConsents);
sagaMiddleware.run(watchGames);
sagaMiddleware.run(watchKyc);
sagaMiddleware.run(watchLimits);
sagaMiddleware.run(watchLoginHistory);
sagaMiddleware.run(watchUser);
sagaMiddleware.run(watchUserPlayStatsAndLimits);
sagaMiddleware.run(watchBonusesSagas);
sagaMiddleware.run(watchWelcomeTextsSagas);
sagaMiddleware.run(watchPromotionsSagas);
sagaMiddleware.run(watchFaqSagas);
sagaMiddleware.run(watchHeaderBannersSagas);
sagaMiddleware.run(watchUserWalletSagas);
sagaMiddleware.run(watchHeroBackgroundsSagas);

// add axios interceptor with access to store
axiosInterceptor(store);
bffApiServiceInterceptor(store);

export default store;

storeSynchronize(store, {
  whitelist: ['bffGames'],
});
